"use client"

import { useEffect } from "react"
import { useLocale } from "next-intl"

/**
 * Syncs <html lang> with the active next-intl locale. Root layout uses
 * defaultLocale + suppressHydrationWarning; this corrects after hydration
 * and on client navigations.
 */
export function HtmlLang() {
  const locale = useLocale()

  useEffect(() => {
    document.documentElement.lang = locale
  }, [locale])

  return null
}
